import { render, staticRenderFns } from "./Barras.vue?vue&type=template&id=e2d9ec9c&"
import script from "./Barras.vue?vue&type=script&lang=js&"
export * from "./Barras.vue?vue&type=script&lang=js&"
import style0 from "./Barras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports